export default __webpack_public_path__ + "static/media/Bannari_Amman_logo.4978dc00.png";